import { Registration } from "./Registration";
import { Login } from "./Login";

export class BankIdAuthenticator {

    Registration(settings) {
        return new Registration(settings);
    }

    Login(settings) {
        return new Login(settings);
    }
}